export default __webpack_public_path__ + "static/media/firebaset.9b9726cd.png";